export default "__VITE_ASSET__a81cae50__"